import {PollRobotTemplate} from './PollRobotTemplate.js';

export class VeedoDrop extends HTMLElement {
	constructor() {
		super();
		[this.el, this.$] = PollRobotTemplate(`VeedoDrop`);
		this.shadow = this.attachShadow({mode:`open`});
	}
	connectedCallback() {
		this.shadow.appendChild(this.el);
		this.$.drop.addEventListener(`dragenter`, evt=>this.dragenter(evt));
		this.$.drop.addEventListener(`dragover`, evt=>this.dragover(evt));
		this.$.drop.addEventListener(`drop`, evt=>this.drop(evt));
		this.$.drop.addEventListener(`dragleave`, evt=>this.dragleave(evt));
	}
	dragenter(evt) {
		evt.preventDefault();
		console.log(`VeedoDrop::dragEnter`);		
	}
	dragover(evt) {
		evt.preventDefault();
		console.log(`VeedoDrop::dragOver`);
		this.$.drop.classList.add(`dragover`);
	}
	drop(evt) {
		evt.preventDefault();
		this.$.drop.classList.remove(`dragover`);
		[...evt.dataTransfer.files].forEach( f=>this.uploadFile(f) );
	}
	dragleave(evt) {
		evt.preventDefault();
		this.$.drop.classList.remove(`dragover`);
	}
	uploadFile(file) {
		let formData = new FormData();
		formData.append(`file`, file);
		fetch(`/veejay/upload`, {
			method: `POST`,
			body: formData
		}).then(
			res=>res.json() )
		.then(
			js=>{
				console.log(js);
			})
		.catch( err=>{
			console.log(err);
			alert(`Failed uploading `, err);
		});
	}
}
customElements.define(`veedo-drop`, VeedoDrop);